export default __webpack_public_path__ + "static/media/java.2c5d38ea.svg";